export function toFormData(
  data: {
    [key: string]: string | number | boolean | File | File[] | null | undefined;
  },
  fileFields?: string[],
  allowNullFields?: string[]
): FormData {
  const formData = new FormData();

  for (const key in data) {
    const value = data[key];

    if (fileFields?.includes(key)) {
      if (value instanceof File) {
        formData.append(key, value);
      } else if (Array.isArray(value)) {
        value.forEach((file) => formData.append(key, file));
      }
    } else if (value !== null && value !== undefined) {
      formData.append(key, String(value));
    } else if (allowNullFields?.includes(key)) {
      formData.append(key, '');
    }
  }

  return formData;
}
